
const dirServicePath = 'https://mdc.im.ac.cn';
const serverUrl = {
    wdcmsop3: {
        search: `${dirServicePath}/refsapi/collection`
    },
    standard: {
        search:  `${dirServicePath}/refsapi/standard`
    },
    browse: {
        getinfo: `${dirServicePath}/refsapi/browse/getinfo`,
        species: `${dirServicePath}/refsapi/browse/species`,
        strain: `${dirServicePath}/refsapi/browse/strain`,
        searchcollection: `${dirServicePath}/refsapi/browse/searchcollection`,
        standard: `${dirServicePath}/refsapi/standard`,
    },
    home: {
        getcount: `${dirServicePath}/refsapi/`
    },
    search: {
        search:  `${dirServicePath}/refsapi/search/searchkey`
    }
}
export default serverUrl;



// WEBPACK FOOTER //
// ./src/js/server-config.js